module.exports = __webpack_public_path__ + "static/img/img-3.755d3b1c.png";